import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
export const ASSET_NAME = 'our-story';

export const loadData = (params, search) => dispatch => {
  const pageAsset = { ourStory: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
